/**
 * Branded EN/AR not-found and error screens (QM-D02-003 / QM-D08-001). The catch-all route renders NotFoundScreen
 * inside the Shell; the root errorElement renders RouteErrorScreen in its own Shell frame, so an unknown path or a
 * crashing screen never shows React Router's default English, unbranded page.
 */
import { Link } from 'react-router';
import { Button, Heading, Panel, Text } from '@qm/ui';
import { AppProvider, useApp } from '../lib/app-context';
import { ShellFrame, type ShellSurface } from './Shell';

export function NotFoundScreen() {
  const { t } = useApp();
  return (
    <Panel data-testid="route-not-found">
      <Heading level={1}>{t('shell.notFound.title')}</Heading>
      <Text tone="muted">{t('shell.notFound.body')}</Text>
      <Link className="qm-text-link" to="/">{t('shell.notFound.home')}</Link>
    </Panel>
  );
}

function ErrorScreen() {
  const { t } = useApp();
  return (
    <Panel role="alert" data-testid="route-error">
      <Heading level={1}>{t('shell.error.title')}</Heading>
      <Text tone="muted">{t('shell.error.body')}</Text>
      <Button onClick={() => window.location.reload()}>{t('shell.error.retry')}</Button>{' '}
      <Link className="qm-text-link" to="/">{t('shell.notFound.home')}</Link>
    </Panel>
  );
}

export function RouteErrorScreen({ surface }: { surface: ShellSurface }) {
  return <AppProvider><ShellFrame surface={surface}><ErrorScreen /></ShellFrame></AppProvider>;
}
